'use client';

import { useRef, useState } from 'react';

/* ==================================================================
   Media Coverage data — each card = one publication feature
   ================================================================== */

const coverage = [
  {
    logo: '/new-logos/times-of-india.png',
    alt: 'The Times of India',
    title:
      'Times Business Awards, North 2024: Acknowledging the very best in Business.',
    excerpt:
      'Shivam Khuswaha, Founder of Cloudastra Technologies stands as a beacon of excellence in ...',
    date: '12 April 2024',
    href: 'https://timesofindia.indiatimes.com/life-style/events/times-business-awards-north-2024-acknowledging-the-very-best-in-business/articleshow/109378158.cms',
  },
  {
    logo: '/new-logos/hindustan-times.png',
    alt: 'Hindustan Times',
    title:
      'Partner in Digital Transformation with Cloudastra Technologies premium IT and Cloud Solutions',
    excerpt:
      "In a rapidly evolving digital presence, embracing cutting-edge technology is no longer an option; it's ...",
    date: '24 February 2024',
    href: 'https://www.hindustantimes.com/brand-stories/partner-in-digital-transformation-with-cloudastra-technologies-premium-it-and-cloud-solutions-101708681005199.html',
  },
  {
    logo: '/new-logos/business-standard.png',
    alt: 'The Business Standard',
    title:
      'Cloudastra Technologies Unveils Nigmabot.AI: A Gateway to AI-Powered Solutions',
    excerpt:
      "In a rapidly evolving digital presence, embracing cutting-edge technology is no longer an option; it's ...",
    date: '23 February 2024',
    href: 'https://www.business-standard.com/content/press-releases-ani/cloudastra-technologies-unveils-nigmabot-ai-a-gateway-to-ai-powered-solutions-124022300429_1.html',
  },
  {
    logo: '/new-logos/ani.png',
    alt: 'ANI',
    title:
      'Cloudastra Technologies, a leading software development agency, is gearing up to launch its MVP Nigmabot.AI',
    excerpt:
      'Cloudastra is renowned for delivering innovative and...',
    date: '23 February 2024',
    href: 'https://www.aninews.in/news/business/cloudastra-technologies-unveils-nigmabotai-a-gateway-to-ai-powered-solutions20240223131207/',
  },
];

/* ==================================================================
   Section
   ================================================================== */

export default function MediaCoverage() {
  const gridRef = useRef(null);
  const cursorRef = useRef(null);
  const [hovering, setHovering] = useState(false);

  const onPointerMove = e => {
    if (!gridRef.current || !cursorRef.current) return;
    const r = gridRef.current.getBoundingClientRect();
    cursorRef.current.style.transform = `translate(${e.clientX - r.left}px, ${e.clientY - r.top}px) translate(-50%, -50%)`;
  };

  return (
    <section
      data-nav-theme="light"
      className="relative bg-white py-20 lg:py-28"
    >
      <div className="mx-auto w-11/12 max-w-[1280px]">
        {/* Heading + subline */}
        <div>
          <h2 className="font-poppins text-3xl font-bold leading-[1.2] sm:leading-[1.2] lg:leading-[1.2] tracking-tight text-[#058BF0] sm:text-4xl lg:text-5xl">
            Media Coverage
          </h2>
          <p className="mt-3 text-base leading-relaxed text-gray-600 lg:text-lg">
            Discover the Latest at Cloudastra: Stay Informed, Stay Ahead!
          </p>
        </div>

        {/* Cards */}
        <div
          ref={gridRef}
          className="relative mt-10 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4 lg:gap-5"
          onPointerMove={onPointerMove}
        >
          {coverage.map((c, i) => (
            <a
              key={i}
              href={c.href}
              target="_blank"
              rel="noopener noreferrer"
              onMouseEnter={() => setHovering(true)}
              onMouseLeave={() => setHovering(false)}
              className="media-card group flex flex-col rounded-2xl p-3 transition-all duration-300 ease-out hover:-translate-y-1 hover:bg-white hover:shadow-[0_24px_50px_-20px_rgba(5,139,240,0.25)] hover:ring-1 hover:ring-[#058BF0]/15 lg:cursor-none"
            >
              {/* Logo plate */}
              <div className="relative flex h-[170px] w-full items-center justify-center overflow-hidden rounded-xl bg-[#e5e5e5] px-8 transition-all duration-300 ease-out group-hover:bg-white group-hover:shadow-inner">
                {/* eslint-disable-next-line @next/next/no-img-element */}
                <img
                  src={c.logo}
                  alt={c.alt}
                  loading="lazy"
                  decoding="async"
                  className="relative z-10 max-h-[64px] w-auto max-w-full object-contain transition-transform duration-300 ease-out group-hover:scale-[1.04]"
                />
                {/* Soft brand-blue glow that fades in on hover */}
                <span
                  aria-hidden
                  className="pointer-events-none absolute -bottom-12 left-1/2 h-32 w-40 -translate-x-1/2 rounded-full bg-[#058BF0]/15 opacity-0 blur-3xl transition-opacity duration-500 group-hover:opacity-100"
                />
              </div>

              {/* Card text */}
              <div className="mt-4 flex flex-1 flex-col px-1">
                <h3 className="text-sm font-bold leading-snug text-[#0a1b3a] transition-colors duration-300 group-hover:text-[#058BF0]">
                  {c.title}
                </h3>
                <p className="mt-3 text-sm leading-relaxed text-gray-600">
                  {c.excerpt}
                </p>
                <p className="mt-4 text-xs text-gray-400">{c.date}</p>
              </div>
            </a>
          ))}

          {/* Custom "Read more" cursor — only visible while hovering a card (desktop) */}
          <div
            ref={cursorRef}
            aria-hidden
            className={`pointer-events-none absolute left-0 top-0 z-50 hidden rounded-full bg-[#0a1b3a] px-4 py-2 text-[10px] font-bold uppercase tracking-[0.18em] text-white shadow-[0_10px_24px_-6px_rgba(10,27,58,0.4)] transition-opacity duration-200 lg:block ${
              hovering ? 'opacity-100' : 'opacity-0'
            }`}
            style={{ willChange: 'transform' }}
          >
            Read more
          </div>
        </div>
      </div>
    </section>
  );
}
